import React from 'react';
import { Users, ShieldCheck, CreditCard } from 'lucide-react';
import type { User } from '../../schemas/validation';

interface StatsCardsProps {
  users: User[];
  subscriptionStats: any;
}

export const StatsCards: React.FC<StatsCardsProps> = ({ users, subscriptionStats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mb-8">
      <div className="card p-6">
        <div className="flex items-center">
          <div className="p-3 rounded-full bg-blue-100">
            <Users className="h-6 w-6 text-blue-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600">Total Users</p>
            <p className="text-2xl font-bold text-gray-900">{users.length}</p>
          </div>
        </div>
      </div>

      <div className="card p-6">
        <div className="flex items-center">
          <div className="p-3 rounded-full bg-purple-100">
            <ShieldCheck className="h-6 w-6 text-purple-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600">Administrators</p>
            <p className="text-2xl font-bold text-gray-900">
              {users.filter(u => u.isAdmin).length}
            </p>
          </div>
        </div>
      </div>

      <div className="card p-6">
        <div className="flex items-center">
          <div className="p-3 rounded-full bg-green-100">
            <Users className="h-6 w-6 text-green-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600">Regular Users</p>
            <p className="text-2xl font-bold text-gray-900">
              {users.filter(u => !u.isAdmin).length}
            </p>
          </div>
        </div>
      </div>

      <div className="card p-6">
        <div className="flex items-center">
          <div className="p-3 rounded-full bg-yellow-100">
            <CreditCard className="h-6 w-6 text-yellow-600" />
          </div>
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600">Active Plans</p>
            <p className="text-2xl font-bold text-gray-900">
              {subscriptionStats?.plans?.length || 3}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
